﻿export class MessageSentEventPayload {

    public object: any;

    constructor(object: any) {
        this.object = object;
    }

}
